// views/Dashboard/PainelExecutivo/components/ModalGraficoExpandido.tsx
import React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

interface Props {
  titulo: string;
  onClose: () => void;
  children: React.ReactNode;
}

// Mesmo padrão de modal fullscreen já usado no projeto (ver
// views/CRM/Kanban/KanbanGraphic.tsx): portal pra document.body, backdrop
// escurecido + desfocado que fecha ao clicar fora.
const ModalGraficoExpandido: React.FC<Props> = ({ titulo, onClose, children }) => {
  return createPortal(
    <div className="fixed inset-0 z-[100] flex items-start justify-center overflow-y-auto p-2 sm:p-4 md:p-10">
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm animate-fade-in" onClick={onClose} />
      <div className="relative bg-white dark:bg-gray-900 rounded-2xl w-full max-w-3xl shadow-2xl flex flex-col my-auto">
        <div className="flex items-center justify-between p-4 border-b border-gray-100 dark:border-gray-800">
          <h2 className="text-base font-bold text-gray-800 dark:text-white">{titulo}</h2>
          <button
            type="button"
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors"
          >
            <X size={20} />
          </button>
        </div>
        <div className="p-4 md:p-6">{children}</div>
      </div>
    </div>,
    document.body
  );
};

export default ModalGraficoExpandido;
